import { REGISTRATION_SOURCES } from 'src/modules/user/models/user';

export const IDP_BASED_REGISTRATION_SOURCES = [
    REGISTRATION_SOURCES.SINGLE_SIGN_ON as string,
    REGISTRATION_SOURCES.SCIM as string,
];

export const isSSOFlowRegistrationSource = (registrationSource: string) =>
    IDP_BASED_REGISTRATION_SOURCES.includes(registrationSource);
